const features = [
  { 
    name: 'Web Scanning', 
    basic: true, 
    premium: true, 
    enterprise: true 
  },
  { 
    name: 'Network Scanning', 
    basic: false, 
    premium: true, 
    enterprise: true 
  },
  { 
    name: 'Cloud Scanning',
    basic: false, 
    premium: false, 
    enterprise: true 
  },
  { 
    name: 'Malware Scanning',
    basic: true,
    premium: true, 
    enterprise: true 
  }
];

export default features;
